import Fr from './fr.js';

export default {
    fr: Fr
};
